function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React, { forwardRef, memo, useRef, useEffect, useCallback } from 'react';
import useSelect from './useSelect';
import { optionType } from './types';
import Option from './Components/Option';
import isSelected from './lib/isSelected';
var SelectSearch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var defaultValue = _ref.value,
    disabled = _ref.disabled,
    placeholder = _ref.placeholder,
    multiple = _ref.multiple,
    search = _ref.search,
    autoFocus = _ref.autoFocus,
    autoComplete = _ref.autoComplete,
    defaultOptions = _ref.options,
    id = _ref.id,
    onChange = _ref.onChange,
    printOptions = _ref.printOptions,
    closeOnSelect = _ref.closeOnSelect,
    className = _ref.className,
    renderValue = _ref.renderValue,
    renderOption = _ref.renderOption,
    renderGroupHeader = _ref.renderGroupHeader,
    getOptions = _ref.getOptions,
    fuse = _ref.fuse,
    emptyMessage = _ref.emptyMessage;
  var selectRef = useRef(null);
  var _useSelect = useSelect({
      options: defaultOptions,
      value: defaultValue,
      multiple: multiple,
      disabled: disabled,
      fuse: fuse,
      search: search,
      onChange: onChange,
      getOptions: getOptions,
      closeOnSelect: closeOnSelect,
      closable: !multiple || printOptions === 'on-focus',
      allowEmpty: !!placeholder
    }),
    _useSelect2 = _slicedToArray(_useSelect, 3),
    snapshot = _useSelect2[0],
    valueProps = _useSelect2[1],
    optionProps = _useSelect2[2];
  var focus = snapshot.focus,
    highlighted = snapshot.highlighted,
    value = snapshot.value,
    options = snapshot.options,
    searching = snapshot.searching,
    displayValue = snapshot.displayValue,
    searchValue = snapshot.search;
  var cls = useCallback(function (key) {
    if (typeof className === 'function') {
      return className(key);
    }
    if (key.indexOf('container') === 0) {
      return key.replace('container', className);
    }
    if (key.indexOf('is-') === 0 || key.indexOf('has-') === 0) {
      return key;
    }
    return className.split(' ')[0] + "__" + key;
  }, [className]);
  var renderEmptyMessage = useCallback(function () {
    if (emptyMessage === null) {
      return null;
    }
    var content = typeof emptyMessage === 'function' ? emptyMessage() : emptyMessage;
    return /*#__PURE__*/React.createElement("li", {
      className: cls('not-found')
    }, content);
  }, [emptyMessage, cls]);
  var wrapperClass = [cls('container'), disabled ? cls('is-disabled') : false, searching ? cls('is-loading') : false, focus ? cls('has-focus') : false].filter(function (single) {
    return !!single;
  }).join(' ');
  var inputValue = focus && search ? searchValue : displayValue;
  useEffect(function () {
    var current = selectRef.current;
    if (!current || multiple || highlighted < 0 && !value) {
      return;
    }
    var query = highlighted > -1 ? "[data-index=\"" + highlighted + "\"]" : "[data-value=\"" + escape(value.value) + "\"]";
    var selected = current.querySelector(query);
    if (selected) {
      var rect = current.getBoundingClientRect();
      var selectedRect = selected.getBoundingClientRect();
      current.scrollTop = selected.offsetTop - rect.height / 2 + selectedRect.height / 2;
    }
  }, [focus, value, highlighted, selectRef, multiple]);
  var shouldRenderOptions;
  switch (printOptions) {
    case 'never':
      shouldRenderOptions = false;
      break;
    case 'always':
      shouldRenderOptions = true;
      break;
    case 'on-focus':
      shouldRenderOptions = focus;
      break;
    default:
      shouldRenderOptions = !disabled && (focus || multiple);
      break;
  }
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: wrapperClass,
    id: id
  }, (!multiple || placeholder || search) && /*#__PURE__*/React.createElement("div", {
    className: cls('value')
  }, renderValue(_objectSpread(_objectSpread({}, valueProps), {}, {
    placeholder: placeholder,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    value: inputValue
  }), snapshot, cls('input'))), shouldRenderOptions && /*#__PURE__*/React.createElement("div", {
    className: cls('select'),
    ref: selectRef,
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: cls('options')
  }, options.length > 0 ? options.map(function (option) {
    var isGroup = option.type === 'group';
    var items = isGroup ? option.items : [option];
    var base = {
      cls: cls,
      optionProps: optionProps,
      renderOption: renderOption
    };
    var rendered = items.map(function (o) {
      return /*#__PURE__*/React.createElement(Option, _extends({
        key: o.value,
        selected: isSelected(o, value),
        highlighted: highlighted === o.index
      }, base, o));
    });
    if (isGroup) {
      return /*#__PURE__*/React.createElement("li", {
        role: "none",
        className: cls('row'),
        key: option.groupId
      }, /*#__PURE__*/React.createElement("div", {
        className: cls('group')
      }, /*#__PURE__*/React.createElement("div", {
        className: cls('group-header')
      }, renderGroupHeader(option.name)), /*#__PURE__*/React.createElement("ul", {
        className: cls('options')
      }, rendered)));
    }
    return rendered;
  }) : renderEmptyMessage() || null)));
});
SelectSearch.defaultProps = {
  className: 'select-search',
  disabled: false,
  search: false,
  multiple: false,
  placeholder: null,
  id: null,
  autoFocus: false,
  autoComplete: 'on',
  value: '',
  onChange: function onChange() {},
  printOptions: 'auto',
  closeOnSelect: true,
  renderOption: function renderOption(domProps, option, snapshot, className) {
    return /*#__PURE__*/(
      // eslint-disable-next-line react/button-has-type
      React.createElement("button", _extends({
        type: "button",
        className: className
      }, domProps), option.name)
    );
  },
  renderGroupHeader: function renderGroupHeader(name) {
    return name;
  },
  renderValue: function renderValue(valueProps, snapshot, className) {
    return /*#__PURE__*/React.createElement("input", _extends({}, valueProps, {
      className: className
    }));
  },
  fuse: {
    keys: ['name', 'groupName'],
    threshold: 0.3
  },
  getOptions: null,
  emptyMessage: null
};
export default /*#__PURE__*/memo(SelectSearch);